<template>
  <div class="space-y-4">
    <template v-if="isExistingUser">
      <EFormField id="users" :label="t(label)">
        <EAutoComplete
          id="users"
          v-model="user"
          :placeholder="t(useTranslationPath(callerPath, 'startTypingToSearch'))"
          value-key="id"
          label-key="name"
          :min-query-length="3"
          :on-search
        />
      </EFormField>

      <EButton :label="t(labelCreate)" variant="link" block @click="onExistingUserToggle" />
    </template>
    <template v-else>
      <EFormField id="newUser" :label="t(labelNew)" :hint="hint ? t(hint) : null">
        <EInput id="newUser" v-model="user" name="newUser" />
      </EFormField>

      <EButton
        :label="t(useTranslationPath(callerPath, 'cancel'))"
        variant="link"
        block
        @click="onExistingUserToggle"
      />
    </template>
  </div>
</template>

<script setup>
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { EAutoComplete, EButton, EFormField, EInput } from '@expansivefm/eds'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
  label: {
    type: String,
    required: false,
    default: () => {
      return useTranslationPath('components.userSelection', 'selectExistingUser')
    },
  },
  labelNew: {
    type: String,
    required: false,
    default: () => {
      return useTranslationPath('components.userSelection', 'newUser')
    },
  },
  labelCreate: {
    type: String,
    required: false,
    default: () => {
      return useTranslationPath('components.userSelection', 'createNewUser')
    },
  },
  hint: {
    type: String,
    required: false,
    default: null,
  },
  onSearch: {
    type: Function,
    required: true,
  },
})

const user = defineModel({ type: [String, Number], default: null })

const { t } = useI18n()

const callerPath = 'components.userSelection'

const isExistingUser = ref(true)

const onExistingUserToggle = () => {
  user.value = null
  isExistingUser.value = !isExistingUser.value
}
</script>
